import {Component, ElementRef, HostListener, OnInit, ViewEncapsulation} from '@angular/core';
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./header.component.scss'],
  host: {
    '(document:click)': 'onClickOutside($event)',
  },
})
export class HeaderComponent implements OnInit {
  joinChat: boolean = true;
  openedMenuItem: string;
  currentLanguage: string = 'en';
  subHeaderData = [
    {
      id: 1,
      title: 'GRC Automation',
      subTitle: 'Easier Compliance Faster Audits',
      link: '/products-grc',
      iconName: 'grc',
    },
    {
      id: 2,
      title: 'Security Awarness',
      subTitle: 'Automated tailored training',
      iconName: 'awareness',
      link: '/products-awareness',
    },
    {
      id: 3,

      title: 'Phishing simulation',
      subTitle: 'Assess employees readiness',
      iconName: 'Phishing-simulation',
      link: '/products-phishing-simulation',
    }
  ]

  subHeaderCompanyData = [
    {
      id: 1,
      title: 'About us',
      subTitle: 'We are a cybersecurity company We specialize in building modern platforms',
      link: '/about-us',
      iconName: 'aboutus'
    },
    // {
    //   id: 2,

    //   title: 'News Blogs',
    //   subTitle: 'Learn about our latest news and tap into',
    //   iconName: 'newsblogs',
    //   link: '/blogs'
    // },
    {
      id: 2,
      title: 'Partners',
      subTitle: 'You can join our list of partners today and work with',
      iconName: 'partners',
      link: '/partner'
    },
    {
      id: 3,

      title: 'Contact us',
      subTitle: 'Reach out about a general enquiry',
      iconName: 'contactus',
      link: '/contact-us'
    }
  ]

  subHeaderServicesData = [
    {
      id: 1,
      title: 'GRC Consulting',
      subTitle: 'We provide full assessment and implementation',
      iconName: 'autonio',
      link: '/services/Consultations'
    },
    {
      id: 2,
      title: 'Managed Awareness',
      subTitle: 'We help you with designing and running',
      link: '/services/Awareness',
      iconName: 'fingercriclee'
    },
    {
      id: 3,
      title: 'Certification',
      subTitle: 'We help you achieve compliance certification',
      iconName: 'vector',
      link: '/services/Compliance'
    },
    
  ]

  subHeaderContactUsData = [
    // {
    //   id: 1,
    //   title: '(+966) 0558188338',
    //   link: '/services',
    //   iconName: 'telephone',
    //   tel: 'tel:+9660558188338'
    // },
    {
      id: 2,
      title: 'Whatsapp',
      iconName: 'whatsapp',
      link: '/'
    },
    {
      id: 3,
      title: 'Online Form',
      iconName: 'contact',
      link: '/contact-us'
    }
  ]

  stickyHeader: any
  selectedSubHeaderInfo: any
  $event: any;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.stickyHeader = document.body.scrollTop > 120 ||
      document.documentElement.scrollTop > 120;
  }
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer, private _eref: ElementRef,public commonService: CommonService) {
    iconRegistry.addSvgIcon(
      "awareness",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/awarenessPlatform.svg")
    );
    iconRegistry.addSvgIcon(
      "Phishing-simulation",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/PhishingSimulation.svg")
    );
    iconRegistry.addSvgIcon(
      "grc",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/GRCAutomationn.svg")
    );
    iconRegistry.addSvgIcon(
      "right-arrow",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/right-arrow.svg")
    );
    iconRegistry.addSvgIcon(
      "menu",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/menu.svg")
    );
    iconRegistry.addSvgIcon(
      "telephone",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/ic_call.svg")
    )
    iconRegistry.addSvgIcon(
      "whatsapp",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/whatsappNew.svg")
    );
    iconRegistry.addSvgIcon(
      "contact",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/ic_copy.svg")
    );
    iconRegistry.addSvgIcon(
      "autonio",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/autonio.svg")
    );
    iconRegistry.addSvgIcon(
      "fingercriclee",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/images/fingercriclee.svg")
    );
    iconRegistry.addSvgIcon(
      "vector",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/Vector.svg")
    );
    iconRegistry.addSvgIcon(
      "aboutus",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/Group39238.svg")
    );
    iconRegistry.addSvgIcon(
      "newsblogs",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/Layer_14.svg")
    );
    iconRegistry.addSvgIcon(
      "partners",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/Layer_15.svg")
    );
    iconRegistry.addSvgIcon(
      "contactus",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/Layer_16.svg")
    );
    iconRegistry.addSvgIcon(
      "arrow-menu",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/arrow-menu.svg")
    );

  }
  onClickOutside(event: any) {
    if (!this._eref.nativeElement.contains(event.target)) // or some similar check
      this.openedMenuItem = ''
  }
  hoverMenuSubMenu(item: any) {
    this.selectedSubHeaderInfo = item
  }
  openMenu(value: string) {
    if (value === this.openedMenuItem) {
      this.openedMenuItem = ''
      return

    }
    this.openedMenuItem = value
  }
  ngOnInit(): void {
    this.selectedSubHeaderInfo = this.subHeaderData[0]
  }

  setLocale() {
    this.commonService.updateLanguage()
    window.location.reload()
  }

  toggleSideMenu() {
    this.commonService.toggleSideMenu()
  }

  menuClick() {
    this.openedMenuItem = ''
    if (this.commonService.isMobile) {
      this.commonService.toggleSideMenu()

    }
  }
}
